import classNames from 'classnames/bind';
import 'moment/locale/vi';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import orderAPI from '~/api/OrderAPI';
import { JSON_PATH, SVGS } from '~/assets/assetsPath';
import config from '~/config';
import { payments } from '~/constants/payments';
import PageNotFound from '~/pages/PageNotFound';
import { updateProductCartStore } from '~/store/actions/CartProductAction';
import { getNumberWithCommas } from '~/utils';
import styles from './CheckOutOrder.module.scss';
import branchAPI from '~/api/BranchAPI';
import { Breadcrumb, Col, Form, Input, Layout, notification, Radio, Row, Select, Space, Modal } from 'antd';
import VouchersModal from '~/components/VouchersModal';
import voucherAPI from '~/api/VoucherAPI';
import moment from 'moment';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { updateInfoOrderStore } from '~/store/actions/OrderAction';

const { Content } = Layout;
const { TextArea } = Input;

const cx = classNames.bind(styles);

export default function CheckOutOrder() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const order = useSelector((state) => state.order.infoOrder);
    const userInfo = useSelector((state) => state.user.userInfo);
    const cartProductInfo = useSelector((state) => state.cartProduct.cartProductInfo);

    const isLogin = userInfo?.id || '';
    const totalPriceProductOrder = localStorage.getItem('totalPriceProductOrder');
    const listProductOrder = JSON.parse(localStorage.getItem('listProductOrder'));
    const addressInfo = order?.address || JSON.parse(localStorage.getItem('addressInfo'));

    const [payment, setPayment] = useState(order?.payment || 'CASH');

    const [provinceList, setProvinceList] = useState(JSON_PATH.DVHCVN.data || []);
    const [districtList, setDistrictList] = useState([]);
    const [wardList, setWardList] = useState([]);

    const [idProducts, setIdProducts] = useState([]);

    const [disableSubmit, setDisableSubmit] = useState(false);

    // Branch
    const [branchList, setBranchList] = useState([]);
    const [branchSelected, setBranchSelected] = useState('');

    // Voucher
    const [isShowVouchers, setIsShowVouchers] = useState(false);
    const [voucherList, setVoucherList] = useState([]);
    const [voucherSelected, setVoucherSelected] = useState({});
    const voucherApply = JSON.parse(localStorage.getItem('voucherSubmit'));
    const [voucherSubmit, setVoucherSubmit] = useState(voucherApply || {});

    const [pricePayment, setPricePayment] = useState(0);
    const [priceDiscount, setPriceDiscount] = useState(0);

    const [form] = Form.useForm();
    const initialValues = {
        name: order?.name || userInfo?.fullname || '',
        phone: order?.phone || userInfo?.phone || '',
        provinceId: addressInfo?.provinceId || null,
        districtId: addressInfo?.districtId || null,
        wardId: addressInfo?.wardId || null,
        address: addressInfo?.address || '',
        note: order?.note || '',
    };

    const updateInfoOrder = () => {
        let address_local = {
            provinceId: form.getFieldValue('provinceId'),
            districtId: form.getFieldValue('districtId'),
            wardId: form.getFieldValue('wardId'),
            address: form.getFieldValue('address'),
        };

        localStorage.setItem('addressInfo', JSON.stringify(address_local));
        dispatch(
            updateInfoOrderStore({
                name: form.getFieldValue('name'),
                phone: form.getFieldValue('phone'),
                address: address_local,
                note: form.getFieldValue('note'),
                payment,
                voucherSubmit,
            }),
        );
    };

    const onFinish = (values) => {
        if (listProductOrder?.length) {
            let address_local = {
                provinceId: values.provinceId,
                districtId: values.districtId,
                wardId: values.wardId,
                address: values.address,
            };

            localStorage.setItem('addressInfo', JSON.stringify(address_local));
            let provinceName = '';
            let districtName = '';
            let wardName = '';
            for (const province of provinceList) {
                if (province.level1_id === values.provinceId) {
                    provinceName = province.name;
                }
            }
            for (const district of districtList) {
                if (district.level2_id === values.districtId) {
                    districtName = district.name;
                }
            }
            for (const ward of wardList) {
                if (ward.level3_id === values.wardId) {
                    wardName = ward.name;
                }
            }
            const data = {
                fullname: values.name,
                phone: values.phone,
                city: provinceName,
                district: districtName,
                ward: wardName,
                address: values.address,
                payment_type: payment,
                note: values.note || '',
                order_item: idProducts,
                order_type: 'PRODUCT',
                branch_id: branchSelected || null,
            };
            if (voucherSubmit?.id) {
                data.voucher_id = voucherSubmit?.id;
            }

            createOrder(data);
        } else {
            notification.open({
                message: 'Please select a product to order',
                duration: 2,
                placement: 'top',
            });
        }
    };

    const createOrder = async (data) => {
        if (disableSubmit) {
            return;
        } else {
            setDisableSubmit(true);
            try {
                const res = await orderAPI.orderProductAPI(data);

                if (res.code === 200) {
                    notification.open({
                        message: 'Order successful',
                        duration: 2,
                        placement: 'top',
                    });

                    // const new_cart = cartProductInfo.filter(
                    //     (elem) => !listProductOrder.find(({ id }) => elem.id === id),
                    // );
                    const new_cart = cartProductInfo.filter(
                        (elem) =>
                            !listProductOrder.find(
                                ({ id, sharer_id }) =>
                                    elem.id === id || (elem.id !== id && elem.sharer_id === sharer_id),
                            ),
                    );
                    dispatch(updateProductCartStore(new_cart));
                    navigate(config.routes.home);
                }
                setDisableSubmit(false);
            } catch (err) {
                console.log(err);
                if (err.message) {
                    notification.open({
                        message: err.message,
                        duration: 2,
                        placement: 'top',
                    });
                }
                setDisableSubmit(false);
            }
        }
    };

    const onChangePayment = (e) => {
        setPayment(e.target.value);
    };

    const onChangeProvince = (val) => {
        form.setFieldsValue({ wardId: undefined, districtId: undefined });

        const index = provinceList.findIndex((x) => x.level1_id === val);
        setDistrictList(provinceList[index].level2s);
    };

    const onChangeDistrict = (val) => {
        form.setFieldsValue({ wardId: undefined });

        const index = districtList.findIndex((x) => x.level2_id === val);
        setWardList(districtList[index].level3s);
    };

    const renderOptions = (_arr = [], value, label) => {
        return _arr.map((item) => {
            return (
                <Select.Option value={item?.[value]} key={item?.[value]}>
                    {item?.[label]}
                </Select.Option>
            );
        });
    };

    const handleSetIdProducts = () => {
        let id_products = [];
        for (const item of listProductOrder) {
            let product = {};
            if (item.sharer_id) {
                product = {
                    item_id: item.id,
                    quantity: item.amount,
                    sharer_id: item.sharer_id,
                };
            } else {
                product = {
                    item_id: item.id,
                    quantity: item.amount,
                };
            }
            id_products.push(product);
        }
        setIdProducts(id_products);
    };
    const getListBranch = async () => {
        try {
            const params = {
                fields: '["$all"]',
            };
            const res = await branchAPI.getBranchList(params);
            const branches = res?.results?.objects?.rows || [];
            setBranchList([...branches]);
            let main_branch = branches.filter((item) => item.is_main);
            setBranchSelected(main_branch[0]?.id || '');
            // form.setFieldsValue({
            //     branch: main_branch[0]?.id || '',
            // });
        } catch (err) {
            console.log(err);
            setBranchList([]);
        }
    };

    const handleShowVouchers = async () => {
        try {
            const Today = moment().startOf('day').format('x');
            const params = {
                fields: `["$all", {"voucher_users": ["$all"]}]`,
                filter: `{"$and": [{"voucher_type": "ORDER"}, {"expiry": {"$gte":"${Today}"}}, {"amount": {"$gt":"0"}}]}`,
                order: '[["created_at","desc"]]',
                page: 1,
                limit: 100,
            };
            const res = await voucherAPI.getListVoucherAPI(params);

            setVoucherList(res?.results?.objects?.rows);
            if (!voucherSubmit?.id) {
                setVoucherSelected({});
            } else {
                setVoucherSelected(voucherSubmit);
            }
            setIsShowVouchers(true);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleSetIdProducts();
        getListBranch();
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (addressInfo?.provinceId) {
            const indexPro = provinceList.findIndex((x) => x.level1_id === addressInfo?.provinceId);
            const distList = provinceList[indexPro].level2s;
            setDistrictList(distList);
            const indexDist = distList.findIndex((x) => x.level2_id === addressInfo?.districtId);
            setWardList(distList[indexDist].level3s);
        }
        //eslint-disable-next-line
    }, [addressInfo?.provinceId]);

    useEffect(() => {
        if (voucherSubmit?.discount) {
            const discount = (totalPriceProductOrder * voucherSubmit?.discount) / 100;
            if (voucherSubmit?.max_discount && voucherSubmit.max_discount < discount) {
                setPriceDiscount(voucherSubmit?.max_discount);
            } else {
                setPriceDiscount(discount);
            }

            setPricePayment(totalPriceProductOrder - discount);
        } else {
            setPriceDiscount(0);
            setPricePayment(totalPriceProductOrder);
        }
    }, [voucherSubmit, totalPriceProductOrder]);

    useEffect(() => {
        if (!isShowVouchers) {
            dispatch(updateInfoOrderStore({}));
        }
        // eslint-disable-next-line
    }, [isShowVouchers]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangMuaSanPham');
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {isLogin ? (
                <Layout className={cx('wrapper')} style={{ backgroundColor: '#fff' }}>
                    <Content>
                        <Breadcrumb className={cx('breadcrumb')}>
                            <Breadcrumb.Item>Product information</Breadcrumb.Item>
                            <Breadcrumb.Item>Shopping Cart</Breadcrumb.Item>
                            <Breadcrumb.Item className={cx('breadcrumbItemActive')}>Place order</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className={cx('headingBlock')}>
                            <h3>Order</h3>
                        </div>
                        <div className={cx('contentBlock')}>
                            <Form onFinish={onFinish} form={form} initialValues={initialValues}>
                                <Row gutter={16}>
                                    {/* Left */}
                                    <Col lg={12} md={24} xs={24}>
                                        <div className={cx('infoBlock')}>
                                            <div className={cx('heading')}>Customer information</div>
                                            <Row gutter={[20, 16]}>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name="name"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter a name',
                                                            },
                                                        ]}
                                                    >
                                                        <Input placeholder="Name *" className={cx('item_input')} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item
                                                        name="phone"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter phone number',
                                                            },
                                                            {
                                                                pattern: new RegExp(/(0[3|5|7|8|9])+([0-9])/),
                                                                message: 'Wrong phone number format',
                                                            },
                                                            { min: 10, message: 'Phone number must have 10 digits' },
                                                        ]}
                                                    >
                                                        <Input
                                                            placeholder="Phone number *"
                                                            className={cx('item_input')}
                                                            maxLength={10}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={8}>
                                                    <Form.Item
                                                        name="provinceId"
                                                        className="mb-12"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please select province/city',
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            placeholder="Province/City *"
                                                            onChange={onChangeProvince}
                                                        >
                                                            {renderOptions(provinceList, 'level1_id', 'name')}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={8}>
                                                    <Form.Item dependencies={['provinceId']}>
                                                        {({ getFieldValue }) => {
                                                            return (
                                                                <Form.Item
                                                                    name="districtId"
                                                                    className="mb-0"
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: 'Please select a district',
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        placeholder="District *"
                                                                        disabled={!getFieldValue('provinceId')}
                                                                        onChange={onChangeDistrict}
                                                                    >
                                                                        {renderOptions(
                                                                            districtList,
                                                                            'level2_id',
                                                                            'name',
                                                                        )}
                                                                    </Select>
                                                                </Form.Item>
                                                            );
                                                        }}
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} sm={8}>
                                                    <Form.Item dependencies={['districtId']} className="mb-0">
                                                        {({ getFieldValue }) => {
                                                            return (
                                                                <Form.Item
                                                                    name="wardId"
                                                                    className="mb-0"
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: 'Please select a ward/commune',
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        placeholder="Ward/Commune *"
                                                                        disabled={!getFieldValue('districtId')}
                                                                    >
                                                                        {renderOptions(wardList, 'level3_id', 'name')}
                                                                    </Select>
                                                                </Form.Item>
                                                            );
                                                        }}
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24}>
                                                    <Form.Item
                                                        name="address"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Please enter an address!',
                                                            },
                                                        ]}
                                                    >
                                                        <Input placeholder="Address *" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('serviceBlock')}>
                                            <Row className={cx('heading', 'row_voucher')} onClick={handleShowVouchers}>
                                                <Col xs={16}>
                                                    <Row align="middle">
                                                        <img src={SVGS.IconVoucher} alt="" />
                                                        <span>
                                                            Discount code
                                                            {voucherSubmit?.id ? (
                                                                <span className={cx('tag_discount')}>
                                                                    -{voucherSubmit?.discount}%
                                                                </span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </span>
                                                    </Row>
                                                </Col>
                                                <Col xs={8}>
                                                    <Row justify="end">
                                                        <img src={SVGS.IconArrowRightBlack} alt="" />
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <Row>
                                                {voucherSubmit?.id ? (
                                                    <div className={cx('voucher_apply')}>
                                                        Discount: {getNumberWithCommas(priceDiscount)} d
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                                {/* {voucherSubmit?.id ? (
                                                    <div className={cx('voucher_apply')}>{voucherSubmit?.name}</div>
                                                ) : (
                                                    ''
                                                )} */}
                                            </Row>
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('serviceBlock')}>
                                            <div className={cx('heading')}>Payment method</div>
                                            <Row>
                                                <Radio.Group onChange={onChangePayment} value={payment}>
                                                    <Space direction="vertical">
                                                        {payments?.map(
                                                            (item) =>
                                                                item.id !== 3 && (
                                                                    <Radio value={item.value}>{item.title}</Radio>
                                                                ),
                                                        )}
                                                    </Space>
                                                </Radio.Group>
                                            </Row>
                                        </div>
                                        <div className={cx('divider')}></div>
                                        <div className={cx('serviceBlock')}>
                                            <div className={cx('heading')}>Notes</div>
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <Form.Item name="note">
                                                        <TextArea placeholder="Notes" rows={3} maxLength={255} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>

                                    {/* Right */}
                                    <Col lg={12} md={24} xs={24}>
                                        <div className={cx('infoBlock')}>
                                            <div className={cx('heading')}>Order information</div>
                                            <div className={cx('infoBooking')}>
                                                <div className={cx('headingInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col xs={12} md={15}>
                                                                        <span className={cx('nameService')}>
                                                                            Product
                                                                        </span>
                                                                    </Col>

                                                                    <Col xs={12} md={9} style={{ textAlign: 'right' }}>
                                                                        <span>Cost</span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className={cx('contentInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={[16, 10]}>
                                                                    {listProductOrder?.length &&
                                                                        listProductOrder?.map((item) => (
                                                                            <Fragment key={item?.key}>
                                                                                <Col xs={12} md={15}>
                                                                                    <span>
                                                                                        {item?.amount}x&nbsp;&nbsp;
                                                                                        {item?.title}
                                                                                    </span>
                                                                                </Col>

                                                                                <Col
                                                                                    xs={12}
                                                                                    md={9}
                                                                                    style={{ textAlign: 'right' }}
                                                                                >
                                                                                    <span>
                                                                                        {getNumberWithCommas(
                                                                                            item?.total_price,
                                                                                        )}
                                                                                        d
                                                                                    </span>
                                                                                </Col>
                                                                            </Fragment>
                                                                        ))}
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>

                                                <div className={cx('contentInfoBooking')}>
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <span className={cx('total-title')}>
                                                                            Total order
                                                                        </span>
                                                                    </Col>
                                                                    <Col span={12} style={{ textAlign: 'right' }}>
                                                                        <span className={cx('total-price')}>
                                                                            {totalPriceProductOrder
                                                                                ? `${getNumberWithCommas(
                                                                                    totalPriceProductOrder,
                                                                                )} d`
                                                                                : '0 pt'}
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <span className={cx('total-title')}>
                                                                            Discount
                                                                        </span>
                                                                    </Col>
                                                                    <Col span={12} style={{ textAlign: 'right' }}>
                                                                        <span className={cx('total-price')}>
                                                                            {getNumberWithCommas(priceDiscount)} d
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <div className={cx('titleInfoBooking')}>
                                                                <Row gutter={16}>
                                                                    <Col span={12}>
                                                                        <span className={cx('total-title')}>
                                                                            Total payment
                                                                        </span>
                                                                    </Col>
                                                                    <Col span={12} style={{ textAlign: 'right' }}>
                                                                        <span className={cx('total-price')}>
                                                                            {getNumberWithCommas(pricePayment)} d
                                                                        </span>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <button className={cx('btnBooking')} disabled={disableSubmit}>
                                                    Book now
                                                </button>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        {isShowVouchers && (
                            <Modal
                                centered
                                visible={isShowVouchers}
                                onCancel={() => setIsShowVouchers(false)}
                                maskClosable={false}
                                footer={null}
                                className="otp-modal"
                                width={580}
                            >
                                <div>
                                    <VouchersModal
                                        voucherList={voucherList}
                                        voucherSelected={voucherSelected}
                                        setVoucherSelected={setVoucherSelected}
                                        setVoucherSubmit={setVoucherSubmit}
                                        setIsShowVouchers={setIsShowVouchers}
                                        totalPriceProductOrder={totalPriceProductOrder}
                                        updateInfoSchedule={updateInfoOrder}
                                    />
                                </div>
                            </Modal>
                        )}
                    </Content>
                </Layout>
            ) : (
                <PageNotFound />
            )}
        </>
    );
}
